import { useCookies } from 'react-cookie'
import dayjs from 'dayjs'
import { useRecoilState } from 'recoil'
import styled from 'styled-components'

import { TYPE_POPUP } from '@/shared/constant/cmdtype'
import { usePopupQueryData } from '@/shared/hooks/reactquery'
import useLockBodyScroll from '@/shared/hooks/useLockBodyScroll'
import { PopupOpenState } from '@/shared/store'

const Popup = () => {
  const [popOpen, setPopOpen] = useRecoilState(PopupOpenState)
  const [cookies, setCookie] = useCookies(['Popup'])
  const { data } = usePopupQueryData(TYPE_POPUP)
  const { ImgPath, LinkPath } = data?.Body?.[0] || {}

  useLockBodyScroll(popOpen && !cookies?.Popup && ImgPath)

  const closeToday = () => {
    if (!cookies?.Popup) {
      setCookie('Popup', 'home', { path: '/', expires: dayjs().endOf('day').toDate() })
      setPopOpen(false)
    }
  }

  return (
    <>
      {popOpen && !cookies?.Popup && ImgPath && (
        <PopupWrap>
          <PopupContent $scale={Math.min(1, window.innerHeight / 603)}>
            <a href={LinkPath} target="_blank" rel="noreferrer">
              <img src={`${process.env.REACT_APP_SERVER_IMAGE_URL}${ImgPath}`} alt="팝업 이미지" />
            </a>
            <div className="bottom">
              <button className="left" onClick={() => closeToday()}>
                오늘 그만 보기
              </button>
              <div className="vertical_line" />
              <button className="right" onClick={() => setPopOpen(false)}>
                닫기
              </button>
            </div>
          </PopupContent>
        </PopupWrap>
      )}
    </>
  )
}
export default Popup

const PopupWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 998;
`

const PopupContent = styled.div<{ $scale: number }>`
  width: 420px;
  min-height: 170px;
  height: auto;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  overflow: hidden;
  transform: scale(${({ $scale }) => $scale});
  transform-origin: center center;

  @media all and (max-width: 540px) {
    width: 360px;
  }
  @media all and (max-width: 400px) {
    margin: 0 20px;
    width: 100%;
  }

  > a {
    display: flex;
    > img {
      width: 100%;
      cursor: pointer;
    }
  }

  .bottom {
    display: flex;
    align-items: center;
    padding: 12px 10px;
    width: 100%;
    gap: 10px;
    background-color: #f3f3f3;

    .left {
      color: #787878;
      text-decoration-line: underline;
    }

    .right {
      color: #454545;
      font-weight: 700;
    }

    .vertical_line {
      width: 1px;
      height: 16px;
      background-color: rgba(0, 0, 0, 0.3);
    }

    > button {
      padding: 10px 0;
      border: none;
      background-color: transparent;
      flex: 1;
      font-family: 'Noto Sans KR', sans-serif;
      font-size: 18px;
    }
  }
`
